export default "__VITE_ASSET__qIox6qju__"